import './framework.less'

import { gsap, CSSPlugin, ScrollToPlugin } from 'gsap/all';
const plugins = [CSSPlugin, ScrollToPlugin];
window.d = document;
window.gsap = gsap;
gsap.registerPlugin(ScrollToPlugin);

const InitVideos = () => {
    const sizzle = videojs('GSSISizzle');
    const hydration = videojs('GSSIHydration');
  
    let elements =  document.querySelectorAll('video');
    let isScrolling = null;

    sizzle.on("playing", (e) => {
        hydration.pause();
    });

    hydration.on("playing", (e) => {
        sizzle.pause();
    });

    const checkPosition = () => {
        elements =  document.querySelectorAll('video');
        elements.forEach( (video) => {
            let position = video.getBoundingClientRect();

                // checking whether fully visible
                let shouldPlay = false;

                if (position.top >= 0 && position.bottom <= window.innerHeight) {
                    shouldPlay = true;
                } else if (position.top < window.innerHeight && position.bottom >= 0) {
                    shouldPlay = true;
                } 
               // console.log("shouldPlay:: ", shouldPlay, " :: playing? :: ", video);
                if(!shouldPlay && video.parentElement.classList.contains("vjs-playing")){
                    video.pause();
                }
        });
    }

        // Listen for scroll events
    window.addEventListener('scroll', function (event) {

        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);

        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function () {

            // Run the callback
            checkPosition();

        }, 66);

    }, false);

}

if (document.readyState !== 'loading') {
    InitVideos();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        InitVideos();
    });
}